import React from 'react';
import ItemForecast from "./ItemForecast";
import useFormApi from "../../../cmn/docAutomation/useFormApi"
import * as fn from "../../../../helper/uiFunctions";

const ItemGridSIHwfc = (props) => {
    const { viewData } = props;
    const [popupName, setPopupName] = React.useState("");
    const [popupData, setPopupData] = React.useState(null);
    const cellRef = React.useRef();
    let formApi = useFormApi();

    if (!viewData)
        return (null)

    const data = viewData.childRows[0].rowValues;

    const loadPopupData = () => {
        let customAction = {
            actionId: "show",
            actionName: "itemForecast",
            actionParam: {
                actionType: "",
                showPopup: "1",
                dtId:data.forcastContainer.dataList.valLDT,
                dId:data.forcastContainer.val,
            },
            containerKey: "custom",
            onSuccess: onSuccess
        };
        
        formApi.runGenericAction(customAction, "itemForecast", viewData, null, null, "", "DashViews", 0, onSuccess);
    }

    const onSuccess = (action, containerKey, rowKey, headerKey, response) => {
        setPopupData(response.mainViewData);
    }

    const showPopup = () => {
        setPopupName("fc");
        
        if(!popupData){
            loadPopupData();
        }
    }

    const hidePopup = () => {
        setPopupName("");
    }

    const renderFC = () => {
        if(fn.compareNumber(data.forcastContainer.dataList.isHid, 0)){
            return(
                <div ref={cellRef} style={{ width: "30px", marginTop: "3px" }} className="uiLink show-popup"
                onMouseOver={showPopup} onMouseLeave={hidePopup}>
                    <span style={{ color: "green", marginRight:"5px" }} >{data.valfcIn.val}</span>
                    <span style={{ color: "red" }} >{data.valfcOut.val}</span >
                    {renderPopup()}
                </div >
            )
        }

        return null;
    }

    const renderPopup = () => {
        if(popupName === "fc" && popupData){
            return(
                <ItemForecast viewData={popupData} anchorRef={cellRef} />
            )
        }

        return null;
    }

    return (
        <div className="saras-cell">
            <div  className={data.valViewOnly.dataList.colCssClass}>
                {data.valViewOnly.val}
            </div>

            {renderFC()}
        </div >
    )
}

export default ItemGridSIHwfc